import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from "./sofiaShopifyOrder.module.css";
import { BounceLoader } from "react-spinners";
import { getBatchShopifySofiaOrder } from "../../../redux/actions/apiActions";
import ShopifySofiaOrders from "./sofiaShopifyOrders/sofiaShopifyOrders";
import Pagination from "../../../components/Paginate/paginate";

function ShopifySofiaOrder() {
  const dispatch = useDispatch();

  const { batchShopifyOrderSofia, loading, paginate } = useSelector((state) => state.apiData);

  useEffect(() => {
    dispatch(getBatchShopifySofiaOrder(1));
  }, [dispatch]);

      const handlePageChange = (page) => {
      dispatch(getBatchShopifySofiaOrder(page)); // ⬅️ usamos el mismo action con page
    };

  return (
    <div className={loading ? style.OrderVtexApiContainerLoading : style.vtexOrderApiContainer}>
      {loading ? (
        <BounceLoader className={style.spinner} color="#61a030" />
      ) : (
        <>
          <div className={style.OrderApiEncabezado}>
            <ul className={`${style.uLlist} nav row`}>
              {["Fecha órdenes","Total Elementos", "Fecha de Inicio", "Fecha de fin", "Duración", "Estado", "Llamar ahora","Descargar CSV"].map((text, idx) => (
                <li key={idx} className="nav-item col">
                  <span className="nav-link">{text}</span>
                </li>
              ))}
            </ul>
          </div>
          <div>
             {batchShopifyOrderSofia?.map((batch, idx) => (
              <ShopifySofiaOrders key={batch._id || idx} item={batch} />
            ))} 
          </div>
        </>
      )}
          <div>
        <Pagination paginate={paginate} isLoading={loading} onPageChange={handlePageChange} />
      </div>
    </div>
  );
}

export default ShopifySofiaOrder;
